import { SET_CARD_PAYMENT, SET_PAYMENT_FROM } from "../actions/PaymentActions";

const initialState = {
  cardPayment: null,
  paymentFrom: null,
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CARD_PAYMENT:
      return {
        ...state,
        cardPayment: action.payload,
      };

    case SET_PAYMENT_FROM:
      return {
        ...state,
        paymentFrom: action.payload,
      };

    default:
      return state;
  }
};

export default paymentReducer;
